export default function normalizeEmail(input) {
  return input
    .replace(/\s/g, '')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');
}
